(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("knockout"), require("survey-core"));
	else if(typeof define === 'function' && define.amd)
		define("survey-knockout-ui", ["knockout", "survey-core"], factory);
	else if(typeof exports === 'object')
		exports["survey-knockout-ui"] = factory(require("knockout"), require("survey-core"));
	else
		root["SurveyKnockout"] = factory(root["ko"], root["Survey"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_knockout__, __WEBPACK_EXTERNAL_MODULE_survey_core__) {
return 